export const MODAL_DIALOG__CREATE_BANNER = 'MODAL_DIALOG__CREATE_BANNER';
export const MODAL_DIALOG__EDIT_BANNER = 'MODAL_DIALOG__EDIT_BANNER';
